import {
  FINANCIAL_STATUSES,
  PAYMENT_METHODS,
  SLN_INVOICE_STATUSES,
  TRANSACTION_STATUSES,
} from "./financialCoreConstants";
import { parseApiErrorMessage } from "./mehrsanOperationsUtils";

export { parseApiErrorMessage };

export const pickField = (obj, camel, pascal) =>
  obj?.[camel] ?? obj?.[pascal] ?? null;

export const formatMoney = (value) => {
  if (value == null || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  return `${n.toLocaleString("fa-IR")} ریال`;
};

export const normalizeList = (res) => {
  const data = res?.data ?? res?.Data;
  return Array.isArray(data) ? data : [];
};

export const normalizeProfile = (res) => {
  if (res?.isSuccess === false) return { error: res, profile: null };
  const data = res?.data ?? res?.Data ?? null;
  return { error: null, profile: data };
};

export const getFinancialStatusLabel = (status, title) => {
  if (title && String(title).trim()) return title;
  const v = Number(status);
  const m = FINANCIAL_STATUSES.find((x) => x.value === v);
  return m?.label ?? "نامشخص";
};

export const getInvoiceStatusLabel = (status, title) => {
  if (title && String(title).trim()) return title;
  const v = Number(status);
  const m = SLN_INVOICE_STATUSES.find((x) => x.value === v);
  return m?.label ?? "نامشخص";
};

export const getPaymentMethodLabel = (method, title) => {
  if (title && String(title).trim()) return title;
  const v = Number(method);
  const m = PAYMENT_METHODS.find((x) => x.value === v);
  return m?.label ?? "نامشخص";
};

export const getTransactionStatusLabel = (status, title) => {
  if (title && String(title).trim()) return title;
  const v = Number(status);
  const m = TRANSACTION_STATUSES.find((x) => x.value === v);
  return m?.label ?? "نامشخص";
};

export const parseAmountInput = (value) => {
  if (value === "" || value == null) return null;
  const n = Number(String(value).replace(/,/g, "").trim());
  return Number.isNaN(n) ? null : n;
};
